module.exports = __webpack_public_path__ + "files/038bb75e7b4097896dc226a9a1eaca93.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-76x76.png
// module id = 1246
// module chunks = 76